
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QRyreportGrid extends Serenity.EntityGrid<QRyreportRow, any> {
        protected getColumnsKey() { return QRyreportColumns.columnsKey; }
        protected getDialogType() { return QRyreportDialog; }
        protected getIdProperty() { return QRyreportRow.idProperty; }
        protected getInsertPermission() { return QRyreportRow.insertPermission; }
        protected getLocalTextPrefix() { return QRyreportRow.localTextPrefix; }
        protected getService() { return QRyreportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}